import { createEvent, restore, sample } from 'effector'
import { fx, path } from '../../../libs'
import { Error, Domain } from './types'
import { toPath } from '../../../features/router'

export const domainMounted = createEvent()
export const setDomain = createEvent<Domain>()
export const setError = createEvent<Error>()
export const submitSaveDomain = createEvent<Domain>()
export const $domain = restore(setDomain, {
  domain: '',
})
export const $error = restore(setError, {
  message: '',
  code: 0,
})

export const getDomain = fx<void, Domain>({
  method: 'GET',
  url: '/forbidden_domain/',
})

export const createDomain = fx<Domain, Domain>({
  method: 'POST',
  url: '/forbidden_domain/',
})

sample({
  clock: [createDomain.doneData],
  fn: (doneData) => {
    toPath(path.forbiddenDomain.entry())
  },
})

sample({
  clock: submitSaveDomain,
  fn: (domain) => {
    return {
      url: `/forbidden_domain`,
      formData: { ...domain },
    }
  },
  target: createDomain,
})

sample({
  clock: [getDomain.failData, createDomain.failData],
  fn: (failData) => {
    return { message: failData.body.message, code: failData.body.code }
  },
  target: [setError],
})

$error
  .on(domainMounted, () => {
    return {
      message: '',
      code: 0,
    }
  })
  .on(submitSaveDomain, () => {
    return {
      message: '',
      code: 0,
    }
  })
